// Repository factory - provides the appropriate repository implementation
// Currently only local repositories are implemented
// When backend is ready, this can be extended to return hybrid repositories

import { TripRepository, SettingsRepository } from './types';
import { localTripRepository } from './LocalTripRepository';
import { localSettingsRepository } from './LocalSettingsRepository';

// Future: when backend is ready, implement RemoteTripRepository and HybridTripRepository
// For now, always return local-only implementations

export function getTripRepository(): TripRepository {
  // TODO: when backend is ready, check isRemoteSyncEnabled() and return hybrid repository
  return localTripRepository;
}

export function getSettingsRepository(): SettingsRepository {
  // TODO: when backend is ready, check isRemoteSyncEnabled() and return hybrid repository
  return localSettingsRepository;
}

// Re-export repository types for convenience
export type { TripRepository, SettingsRepository, Settings } from './types';
